<template>
    <Modal v-model="modal" :width="800" :title="title" @on-visible-change="newsMmodalTrigger($event)" :footer-hide="true">
        <div v-html="content"></div>
    </Modal>
</template>

<script>
import api from '@/api/index';
export default {
    name: 'custImportantNewsDetail',
    props: {
        newsshow: Boolean,
        newstitle: String,
        newsid: String
    },
    data() {
        return {
            modal: this.newsshow,
            title: '123',
            id: '',
            content: ''
        };
    },
    watch: {
        newsshow(vel, oldVel) {
            this.modal = vel;
        },
        newsid(vel, oldVel) {
            this.id = vel;
            this.getImportantNewsByID();
        },
        newstitle(vel, oldVel) {
            this.title = vel;
        }
    },
    methods: {
        async getImportantNewsByID() {
            let res = await api.getImportantNewsByID(this.id);
            if (res.code !== 200) {
                this.content = '请求失败';
                return;
            }
            this.content = res.data.content;
        },
        newsMmodalTrigger(val) {
            this.$emit('changeShow', val);
        }
    }
};
</script>
